import { useState } from "react";

/**
 * Runs an async action and tells whether it is still running, e.g. to show
 * a loading button.
 *
 * @param {(...args: any[]) => Promise<void> | void} action
 * @returns {[boolean, (...args: any[]) => Promise<void>]}
 */
export const usePendingAction = (action) => {
  const [isPending, setIsPending] = useState(false);

  const run = async (...args) => {
    setIsPending(true);

    try {
      await action(...args);
    } finally {
      setIsPending(false);
    }
  };

  return [isPending, run];
};
